
import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const GarantiaDB = async ({folio, id_cab_inst, id_cab_gar, item_id, item, categoria, price, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await addDoc(collection(db, 'bitacoragarantia'), {
        folio: folio,
        id_cab_inst: id_cab_inst,
        id_cab_gar: id_cab_gar,
        item_id: item_id,
        item: item,
        categoria: categoria,
        price: price,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id
    })
}

export default GarantiaDB;